import { createSelector } from 'reselect';
import * as fromCore from '../../core/reducers';
import { accountOwnerCollectionFeatureKey } from '../reducers/account-owner-collection.reducer';

export const getAccountOwnerCollectionState = createSelector(
  fromCore.getCoreState,
  (state) => state[accountOwnerCollectionFeatureKey]
);
export const getAccountOwnerCollectionLoaded = createSelector(
  getAccountOwnerCollectionState,
  (state) => state.loaded
);
export const getAccountOwnerCollectionLoading = createSelector(
  getAccountOwnerCollectionState,
  (state) => state.loading
);
export const getAccountOwnerCollection = createSelector(
  getAccountOwnerCollectionState,
  (state) => state.items
);
